<template>
<div>
<DataTable 
:value="suppliers" 
:lazy="true" 
:paginator="true" 
class="p-datatable-suppliers" 
:rows="rows"
:page="page+1"
:first="first"
:totalRecords="totalRecords"
dataKey="id" 
:rowHover="true" 
v-model:selection="selectedSuppliers" 
v-model:filters="filters" 
filterDisplay="menu" 
:loading="loading"
@page="onPage($event)" 
@sort="onSort($event)" 
@filter="onFilter($event)"
paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
:rowsPerPageOptions="[5,10,25,50,100]"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
:globalFilterFields="['name','suppliercode','brand.name','flow_status']" 
responsiveLayout="scroll"
>
            <template #header>
            	<div class="grid">
            		
                    <!--
            		<div class="col-12 md:col-8  pt-1">

                        <div class="flex justify-content-start  align-items-center" v-if="display_page!=='suppliers'">
                            <Dropdown v-if="customattributes.length && display_page!=='suppliers'" v-model="selected_customattribute" :placeholder="$store.state.languages.lang_phrases.ozel_nitelik_ile_filtrele" :options="customattributes" optionLabel="name" :editable="false" @change="selectCustomAttribute"  class=" p-inputtext-sm" />

                            <template v-if="selected_customattribute">
                                <template v-if="selected_customattribute.type=='number'">
                                    <InputText v-model="customattribute_query.numerical_val" type="number" placeholder="Değer" class="w-full p-inputtext-sm ml-2"/>
                                    <Dropdown  v-model="customattribute_query.numerical_operation" placeholder="Karşılaştırma" :options="numerical_operations" optionLabel="name" optionValue="code" :editable="false" @change="customAttributeQuerySet"  class=" ml-2 p-inputtext-sm" />
                                </template>

                                <template v-if="selected_customattribute.type=='string'">
                                    <InputText v-model="customattribute_query.text_val" placeholder="Değer" class="w-full p-inputtext-sm ml-2"/>
                                    <Dropdown  v-model="customattribute_query.text_operation" placeholder="Karşılaştırma" :options="text_operations" optionLabel="name" optionValue="code" :editable="false" @change="customAttributeQuerySet"  class=" ml-2 p-inputtext-sm" />
                                </template>

                                <template v-if="selected_customattribute.type=='select'">
                                    <Dropdown  v-model="customattribute_query.numerical_val" placeholder="İşartetli Değer" :options="selected_customattribute.options" optionLabel="name" optionValue="id" :editable="false" @change="customAttributeQuerySet"  class=" ml-2 p-inputtext-sm" />
                                </template>

                                <template v-if="selected_customattribute.type=='boolean'">
                                    <Dropdown  v-model="customattribute_query.numerical_val" placeholder="İşaretli Değer" :options="booleanoptions" optionLabel="name" optionValue="code" :editable="false" @change="customAttributeQuerySet"  class=" ml-2 p-inputtext-sm" />
                                </template>



                            <Button icon="pi pi-times" class="p-button-rounded p-button-primary p-button-text ml-2" @click="clearCustomAttributeSelection"/>
                            </template>
                        </div>

                    </div>

                    -->
                    

                    <div class="col-12 md:col-4  pt-1"><p class="text-purple-500 mb-0 mt-1 text-base">{{totalRecords}} {{$store.state.languages.lang_phrases.sonuc_bulundu}}</p></div>

                    <div class="col-12 md:col-8 pt-1 flex justify-content-end">
                        <div class="col-12 md:col-3  pt-1">
                        <div class="flex justify-content-start  md:justify-content-end align-items-center">
                            <Dropdown v-if="selectedSuppliers.length" v-model="selectedaction" :placeholder="$store.state.languages.lang_phrases.secili_ogeleri+'...'" :options="selectedactions" optionLabel="name" :editable="false" optionDisabled="disabled" @change="selectAction" class=" p-inputtext-sm  w-full "/> 
                        </div>
                    </div>


                    <div class="col-12 md:col-3  pt-1  justify-content-center flex" v-if="display_page=='brand'">
                        <small class="text-primary text-sm pt-2 mr-1">Silinen Firmalar Dahil</small>
                        <InputSwitch v-model="include_deactive" @change="inclusionChanged" class="mt-1" />
                    </div>


                     <div class="col-12 md:col-3  pt-1" v-if="display_page!=='suppliers'">
                        
                    <template v-if="customattributefilters.length">
                      <Button label="Özel Nitelikle Filtrele" class=" p-button-danger p-button-outlined   p-button-sm w-full"  icon="pi pi-filter" @click="openCustomAttributeFilterDialog" :badge="customattributefilters.length.toString()" badgeClass="p-badge-danger"></Button>
                    </template>
                    <template v-else>
                      <Button label="Özel Nitelikle Filtrele" class=" p-button-danger p-button-outlined   p-button-sm w-full"  icon="pi pi-filter" @click="openCustomAttributeFilterDialog" ></Button>
                    </template>
                    </div>

                    <div class="col-12 md:col-3 p-0 ">
                        <div class="flex justify-content-start md:justify-content-end align-items-center ">
                            <span class="p-input-icon-left w-full ">
                                <i class="pi pi-search" />
                                <InputText v-model="filters['global'].value" :placeholder="$store.state.languages.lang_phrases.arama" class="w-full p-inputtext-sm" @input="searchSupplier" :showClear="true"/>
                            </span>
                        </div>
                    </div>

                    </div>

                    

                    

            	</div>
                 
            </template>
            <template #empty>
                {{$store.state.languages.lang_phrases.sonuc_bulunamadi}}
            </template>
            <template #loading>
                <div class="loading_overlay">
                    <ProgressSpinner style="width:50px;height:50px" strokeWidth="4" color="deneme" />
               {{$store.state.languages.lang_phrases.yukleniyor_lutfen_bekleyin}}
            </div>
            </template>
            <Column selectionMode="multiple" headerStyle="width: 3rem" v-if="display_page!=='suppliers'" ></Column>
            <Column field="name" :header="$store.state.languages.lang_phrases.isim" sortable style="min-width: 15rem;max-width:20rem">
                <template #body="{data}">
                    <template v-if="display_page=='brand' || display_page=='suppliers'">
                        <router-link  class="text-primary p-link no-underline" tag="span" :to="{ name: 'Supplier' , params: {id:data.id}}" >{{data.name}}</router-link>
                    </template>
                    <template v-if="display_page=='project'">
                        <template v-if="data.uuid">
                            <router-link  class="text-primary p-link no-underline" tag="span" :to="{ name: 'SupplierProject' , params: {id:data.id,project_id:data.uuid}}" >{{data.name}}</router-link>
                        </template>
                        <template v-else>
                            {{data.name}}
                        </template>
                        
                    </template>
                    <template v-if="display_page=='flow'">
                        <template v-if="data.uuid">
                            <router-link  class="text-primary p-link no-underline" tag="span" :to="{ name: 'SupplierProjectFlowSummary' , params: {id:data.id,project_id:data.projectsupplier_id,flow_id:data.uuid}}" >{{data.name}}</router-link>
                        </template>
                        <template v-else>
                            {{data.name}}
                        </template>
                        
                    </template>
                    
                </template>
               
            </Column>
            <Column field="suppliercode" :header="$store.state.languages.lang_phrases.tedarikci_kodu" sortable style="min-width: 14rem">
                <template #body="{data}">
                    {{data.suppliercode}}
                </template>
                    <InputText type="text" v-model="filterModel.value" class="p-column-filter" placeholder="Search by suppliercode"/>
            </Column>

            <template v-if="include_deactive">
                <Column field="status" :header="$store.state.languages.lang_phrases.tedarikci_durumu" sortable style="min-width: 14rem">
                <template #body="{data}">
                    <template v-if="data.status===null || data.status===1">
                        <Button :label="$store.state.languages.lang_phrases.aktif" class=" p-button-success p-button-outlined p-button-sm "  type="button" ></Button>
                    </template>
                    <template v-else>
                        <Button :label="$store.state.languages.lang_phrases.deaktif" class=" p-button-danger p-button-outlined p-button-sm " type="button"></Button>
                    </template>
                </template>
                    
            </Column>
            </template>

            
            <Column field="brand" filterField="brand.name" v-if="show_brand" :header="$store.state.languages.lang_phrases.marka" sortable filterMatchMode="contains" style="min-width: 14rem">
                 <template #body="{data}">
                    {{data.brand.name}}
                </template>
               
            </Column>
            <!--
            <Column field="projects" v-if="show_projects" :header="$store.state.languages.lang_phrases.projeler"  filterMatchMode="contains" style="min-width: 14rem">
                 <template #body="{data}">
                    <TableTag :data="data.projectsuppliers" type="project" v-if="data.projectsuppliers.length"></TableTag>
                    
                </template>
               
            </Column>
            -->

            <Column field="activeflow_type" v-if="show_flows" :header="$store.state.languages.lang_phrases.aktif_akis"  filterMatchMode="contains" style="min-width: 14rem">
                 <template #body="{data}">
                    <Tag 
                    class="ml-2  mb-2 custom-chip" 
                    v-if="data.activeflow_type=='self_evaluation'"
                    :value="data.activeflow_name" 
                    style="background-color:#ff6600"
                    />
                    <Tag 
                    class="ml-2  mb-2 custom-chip" 
                    v-if="data.activeflow_type=='education'"
                    :value="data.activeflow_name" 
                    style="background-color:#3b82f6"
                    />
                    <Tag 
                    class="ml-2  mb-2 custom-chip" 
                    v-if="data.activeflow_type=='verification'"
                    :value="data.activeflow_name" 
                    style="background-color:#7e2f8d"
                    />
                    <Tag 
                    class="ml-2  mb-2 custom-chip" 
                    v-if="data.activeflow_type=='audit'"
                    :value="data.activeflow_name" 
                    style="background-color:#352f8d"
                    />
                </template>

               
            </Column>




          

            <Column field="flow_status"  :header="$store.state.languages.lang_phrases.durum"  :filterMenuStyle="{'width':'14rem'}"  v-if="show_flow_status" style="min-width:12rem">
                    <template #body="{data}">
                    <template v-if="data.flow_status=='created'">
                        <Tag 
                            class="mr-2  custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.olusturuldu" 
                            :style="'background-color:#352f8d'"
                            />
                    </template>
                    <template v-if="data.flow_status=='viewed'">
                        <Tag 
                            class="mr-2  custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.goruntulendi" 
                            :style="'background-color:#7e2f8d'"
                            />
                    </template>
                    <template v-if="data.flow_status=='started'">
                        <Tag 
                            class="mr-2  custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.baslandi" 
                            :style="'background-color:#dd4b39'"
                            />
                    </template>
                    <template v-if="data.flow_status=='finished'">
                        <Tag 
                            class="mr-2  custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.tamamlandi0" 
                            :style="'background-color:#4dc247'"
                            />
                    </template>
                    <template v-if="data.flow_status=='under_review'">
                        <Tag 
                            class="mr-2  custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.degerlendirmede" 
                            :style="'background-color:#ff6600'"
                            />
                    </template>
                    <template v-if="data.flow_status=='canceled'">
                        <Tag 
                            class="mr-2  custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.iptal_edildi" 
                            :style="'background-color:#a82400'"
                            />
                    </template>
                    <template v-if="data.flow_status=='correction_requested'">
                        <Tag 
                            class="mr-2  custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede" 
                            :style="'background-color:#3b82f6'"
                            />
                    </template>
                </template>


                   

                    <template #filter="{filterModel,filterCallback}">
                        <MultiSelect v-model="filterModel.value" :options="statuses" placeholder="Hepsi" class="p-column-filter" :showClear="true"  display="chip" optionLabel="name">
                            
                            <template #option="slotProps">
                                <span :class="'customer-badge status-' + slotProps.option">{{slotProps.option.name}}</span>
                            </template>
                        </MultiSelect>
                    </template>

                    
                </Column>

            <!--
            <template v-if="display_page=='project'">

            <Column  :header="$store.state.languages.lang_phrases.verified" >
            <template #body="{data}">
                <p v-html="$filters.booleanView( data.verified)" class="my-0"></p>
            </template>
            </Column>
            </template>
            -->

            <template v-if="display_page=='suppliers'">
            <Column  :header="$store.state.languages.lang_phrases.durum" >
            <template #body="{data}">
                <p v-if="data.status===0" class="my-0 text-center text-red-500 mt-0 mb-1 font-medium  border-2 border-solid border-round-sm">{{$store.state.languages.lang_phrases.deaktif}}</p>
                <p v-if="data.status===1" class="my-0 text-center text-green-500 mt-0 mb-1 font-medium  border-2 border-solid border-round-sm">{{$store.state.languages.lang_phrases.aktif}}</p>
                <p v-if="!data.status && data.status!==0" class="my-0 text-center text-green-500 mt-0 mb-1 font-medium  border-2 border-solid border-round-sm">{{$store.state.languages.lang_phrases.aktif}}</p>
            </template>
            </Column>
            </template>

             


            <!--
            <Column field="flow_status" filterField="flow_status" v-if="show_flow_status" :header="$store.state.languages.lang_phrases.durum" :showFilterMenu="false" style="min-width: 14rem">
                  

                 <template #body="{data}">
                    <template v-if="data.flow_status=='created'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.olusturuldu" 
                            :style="'background-color:#352f8d'"
                            />
                    </template>
                    <template v-if="data.flow_status=='viewed'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.goruntulendi" 
                            :style="'background-color:#7e2f8d'"
                            />
                    </template>
                    <template v-if="data.flow_status=='started'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.baslandi" 
                            :style="'background-color:#dd4b39'"
                            />
                    </template>
                    <template v-if="data.flow_status=='finished'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.tamamlandi0" 
                            :style="'background-color:#4dc247'"
                            />
                    </template>
                    <template v-if="data.flow_status=='under_review'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.degerlendirmede" 
                            :style="'background-color:#ff6600'"
                            />
                    </template>
                    <template v-if="data.flow_status=='canceled'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.iptal_edildi" 
                            :style="'background-color:#a82400'"
                            />
                    </template>
                    <template v-if="data.flow_status=='correction_requested'">
                        <Tag 
                            class="mr-2 mt-1 custom-chip" 
                            :value="this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede" 
                            :style="'background-color:#3b82f6'"
                            />
                    </template>
                </template>


               
            </Column>-->


        	
           
            
            <Column field="date" :header="$store.state.languages.lang_phrases.eklenme_tarihi" sortable dataType="date" style="min-width: 8rem">
                <template #body="{data}">
                    {{ $filters.momentFormat( data.created_at," Do MM YYYY HH:mm")}}
                </template>
                    <Calendar v-model="filterModel.value" dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" />
            </Column>

            <Column field="date_updated" :header="$store.state.languages.lang_phrases.guncelleme_tarihi" sortable dataType="date" style="min-width: 8rem">
                <template #body="{data}">
                    {{ $filters.momentFormat( data.updated_at," Do MM YYYY HH:mm")}}
                </template>
                    <Calendar v-model="filterModel.value" dateFormat="mm/dd/yy" placeholder="mm/dd/yyyy" />
            </Column>

            <Column v-for="column in customattributefilters" :field="column.id.toString()"
            :header='getTheTranslation(column,"translation")' 
            sortable dataType="date" style="min-width: 8rem">
            <template #body="{data}">
                 <SuppliersTableAttributeColumn :column="column" :row="data" v-if="!loading"/>
            </template>
                    
            </Column>
            
            
            
            <Column headerStyle="width: 4rem; text-align: center" bodyStyle="text-align: center; overflow: visible">
                <template #body="{data}">
                   <Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event,data.id)" aria-haspopup="true" :aria-controls="'overlay_menu'+data.id" class="p-button-primary p-button-text p-button-sm mt-1"   />

                    <template v-if="display_page=='brand'">
                        <Menu :id="'overlay_menu'+data.id" :ref="'menu'+data.id" :model="brand_menuitems" :popup="true">
                         <template #item="{item}">  
                        <a class="p-menuitem-link" role="menuitem" @click="item.command(item.argument,{id:data.id})">
                        <span :class="'p-menuitem-icon '+item.icon"></span>
                        <span class="p-menuitem-text">{{item.label}}</span>
                        <span class="p-ink"></span></a>
                        </template>
                        </Menu>
                        
                    </template>
                    <template v-if="display_page=='project'">
                        <Menu :id="'overlay_menu'+data.id" :ref="'menu'+data.id" :model="project_menuitems" :popup="true">
                         <template #item="{item}">  
                        <a class="p-menuitem-link" role="menuitem" @click="item.command(item.argument,{id:data})">
                        <span :class="'p-menuitem-icon '+item.icon"></span>
                        <span class="p-menuitem-text">{{item.label}}</span>
                        <span class="p-ink"></span></a>
                        </template>
                        </Menu>
                        
                    </template>
                    <template v-if="display_page=='flow'">
                        <Menu :id="'overlay_menu'+data.id" :ref="'menu'+data.id" :model="flow_menuitems" :popup="true">
                         <template #item="{item}">  
                        <a class="p-menuitem-link" role="menuitem" @click="item.command(item.argument,data)">
                        <span :class="'p-menuitem-icon '+item.icon"></span>
                        <span class="p-menuitem-text">{{item.label}}</span>
                        <span class="p-ink"></span></a>
                        </template>
                        </Menu>
                        
                    </template>
                    <template v-if="display_page=='suppliers'">
                        <Menu :id="'overlay_menu'+data.id" :ref="'menu'+data.id" :model="suppliers_menuitems" :popup="true">
                         <template #item="{item}">  
                        <a class="p-menuitem-link" role="menuitem" @click="item.command(item.argument,{id:data.id})">
                        <span :class="'p-menuitem-icon '+item.icon"></span>
                        <span class="p-menuitem-text">{{item.label}}</span>
                        <span class="p-ink"></span></a>
                        </template>
                        </Menu>
                        
                    </template>

					



                </template>
            </Column>
        </DataTable>
<SuppliersTableProjectsModal 
ref="projects" 
:selectedsuppliers="selectedSuppliers" 
@closemodal="closemodal">
    
</SuppliersTableProjectsModal>

<SuppliersTableFlowsModal 
ref="flows" 
:selectedsuppliers="selectedSuppliers" 
@closemodal="closemodal">
    
</SuppliersTableFlowsModal>

<SuppliersTableCustomAttributesModal 
ref="customattributes" 
:selectedsuppliers="selectedSuppliers" 
@closemodal="closemodal" 
:customattributes="customattributes">
    
</SuppliersTableCustomAttributesModal>

<SupplierMarkingsDownloadModal 
ref="markingdownloads"  
@closemodal="closemodal"
:selectedsuppliers="selectedSuppliers" 
>
</SupplierMarkingsDownloadModal>


<SuppliersTableDeleteFromProjectsModal ref="deletefromprojects" :selectedsuppliers="selectedSuppliers" @closemodal="closemodal"></SuppliersTableDeleteFromProjectsModal>



<SuppliersCustomAttributeFilter 
ref="customattributedialog" 
:brand_id="brand_id" 
:filters="customattributefilters" 
@filterSelected="customAttributeFilterSelected"
/>


</div>
</template>

<script>
import {FilterMatchMode,FilterOperator} from 'primevue/api';
import SuppliersTableProjectsModal from "./SuppliersTableProjectsModal"
import SuppliersTableFlowsModal from "./SuppliersTableFlowsModal"
import SuppliersTableCustomAttributesModal from "./SuppliersTableCustomAttributesModal"
import SupplierMarkingsDownloadModal from "./SupplierMarkingsDownloadModal"
import SuppliersTableDeleteFromProjectsModal from "./SuppliersTableDeleteFromProjectsModal"
import SuppliersCustomAttributeFilter from "./SuppliersCustomAttributeFilter"
import SuppliersTableAttributeColumn from "./SuppliersTableAttributeColumn"




import TableTag from "./TableTag"


export default {

  name: '"SuppliersTable"',
  components:{SuppliersTableProjectsModal,SuppliersTableFlowsModal,TableTag,SuppliersTableCustomAttributesModal,SupplierMarkingsDownloadModal,SuppliersTableDeleteFromProjectsModal,SuppliersCustomAttributeFilter,SuppliersTableAttributeColumn},
  props:["suppliers","show_brand","show_projects","show_flows","display_page","show_flow_status","loading","totalRecords","rows","page","customattributes","brand_id"],
  data () {
    return {
    	selectedSuppliers:[],
        first:0,
        intervalobj:null,
    	selectedaction:"placeholder",
        selected_customattribute:null,
        customattributefilters:[],
        include_deactive:false,
        customattribute_query:{
            customattribute_id:null,
            customattribute_type:null,
            numerical_val:null,
            numerical_operation:null,
            text_val:null,
            text_operation:null,
        },
        numerical_operations:[
        {name:"değerine eşitse",code:"equal_to"},
        {name:"değerine eşit değilse",code:"not_equal_to"},
        {name:"değerinden büyükse",code:"greater_than"},
        {name:"değerinden küçükse",code:"less_than"},
        {name:"değer girildiyse",code:"input_filled"},
        ],
        text_operations:[
        {name:"Terimini içeriyorsa",code:"includes"},
        {name:"Terimini içermiyorsa",code:"does_not_include"},
        {name:"değer girildiyse",code:"input_filled"},
        ],
        booleanoptions:[
        {name:"Açık",code:1},
        {name:"Kapalı",code:0},
        ],
    	filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'name': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
        'suppliercode': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]},
        'date': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.DATE_IS}]},
        'flow_status': {value: null, matchMode: FilterMatchMode.EQUALS},
    	},
    	brand_menuitems: [
            {
                label: 'Görüntüle',
                icon: 'pi pi-eye',
                argument:"Supplier",
                command: (argument,id) => {
                    console.log(argument)
                    console.log(id)
                    this.gotoPage(argument,id)
                    }
            },
            {
                label: 'Markadan Sil',
                icon: 'pi pi-trash',
                argument:"brandsupplier",
                command: (argument,id) => {
                console.log(argument)
                console.log(id)
                //this.deleteItem(argument,id)
                }
            },
        ],
        project_menuitems: [
            {
                label: 'Görüntüle',
                icon: 'pi pi-eye',
                argument:"Supplier",
                command: (argument,id) => {
                    console.log(argument)
                    console.log(id)
                    this.gotoPage(argument,id)
                    }
            },
            {
                label: 'Projeden Sil',
                icon: 'pi pi-trash',
                argument:"projectsupplier",
                command: (argument,id) => {
                    console.log(argument)
                    console.log(id.id.uuid)
                    //return false
                    this.deleteItem(argument,id.id.uuid)
                    }
            },
        ],
        flow_menuitems: [
            {
                label: 'Görüntüle',
                icon: 'pi pi-eye',
                argument:"Supplier",
                    command: (argument,data) => {
                    console.log(argument)
                    console.log(data)
                    this.$router.push({ name: "Supplier", params:{ id:data.supplier_id} })
                }
            },
            {
                label: 'Akıştan Sil',
                icon: 'pi pi-trash',
                argument:"flowsupplier",
                command: (argument,data) => {
                    console.log(argument)
                    console.log(data)
                    //return false
                    this.deleteItem(argument,data.flowsupplier_id)
                }
            },
        ],
        suppliers_menuitems: [
            {
                label: 'Görüntüle',
                icon: 'pi pi-eye',
                argument:"Supplier",
                command: (argument,id) => {
                    console.log(argument)
                    console.log(id)
                    this.gotoPage(argument,id)
                    }
            },
            {
                label: 'Sil',
                icon: 'pi pi-trash',
                argument:"supplier",
                command: (argument,id) => {
                console.log(argument)
                console.log(id)
                //return false
                this.deleteItem(argument,id)
                    }
            },
        ],

    }
  },
  computed:{
    deletedstate()
    {
        return this.$store.state.ui.deletedstate
    },
    statuses()
    {
        let arr = [
        {name:this.$store.state.languages.lang_phrases.olusturuldu,id:"created"},
        {name:this.$store.state.languages.lang_phrases.goruntulendi,id:"viewed"},
        {name:this.$store.state.languages.lang_phrases.baslandi,id:"started"},
        {name:this.$store.state.languages.lang_phrases.tamamlandi0,id:"finished"},
        {name:this.$store.state.languages.lang_phrases.degerlendirmede,id:"under_review"},
        {name:this.$store.state.languages.lang_phrases.iptal_edildi,id:"canceled"},
        {name:this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede,id:"correction_requested"},
        ]
        return  arr
    },
    is_self_evaluation()
    {
        if(this.$store.state.flows.flow && this.$store.state.flows.flow.type=="self_evaluation")
        {
            return false
        }
        return true
    },
    selectedactions()
    {
     if(this.display_page=="brand")
        {
            return [
                    {
                        name:"Seçili öğeleri...",
                        action:"placeholder",
                        disabled:true
                    },
                    {
                        name:"Akışa Ekle",
                        action:"add_to_flow"
                    }, 
                    {
                        name:"Özel Nitelik Güncelle",
                        action:"update_custom_attribute"
                    },
                    {
                        name:"Sil",
                        action:"delete"
                    }
                    ]
        }

        if(this.display_page=="project")
        {
            return [
                    {
                        name:"Seçili öğeleri...",
                        action:"placeholder",
                        disabled:true
                    },
                    {
                        name:"Akışa Ekle",
                        action:"add_to_flow"
                    }, 
                    {
                        name:"Bu Projeden Çıkar",
                        action:"remove_from_project"
                    },                 
                    {
                        name:"Özel Nitelik Güncelle",
                        action:"update_custom_attribute"
                    },
                    {
                        name:"Sil",
                        action:"delete"
                    }
                    ]
        }

        if(this.display_page=="flow")
        {
            return [
                    {
                        name:"Seçili öğeleri...",
                        action:"placeholder",
                        disabled:true
                    },
                    {
                        name:"Akışa Ekle",
                        action:"add_to_flow"
                    },
                    {
                        name:"Bu Akıştan Çıkar",
                        action:"remove_from_flow"
                    },
                    {
                        name:"Ön Planlama Oluştur",
                        action:"create_preaudit",
                        disabled:this.is_self_evaluation
                    },                 
                    {
                        name:"Özel Nitelik Güncelle",
                        action:"update_custom_attribute"
                    },               
                    {
                        name:"İşaretleme Raporunu İndir",
                        action:"download_marking_report"
                    },
                    {
                        name:"Sil",
                        action:"delete"
                    }
                    ]
        }

        if(this.display_page=="suppliers")
        {
            return [
                    {
                        name:"Seçili öğeleri...",
                        action:"placeholder",
                        disabled:true
                    },
                    {
                        name:"Sil",
                        action:"delete"
                    }
                    ]
        }

    },
  },
  methods:{
    inclusionChanged()
    {
        
        this.$emit("inclusionChanged",this.include_deactive)
    },
    customAttributeFilterSelected(data)
    {
        console.log("customAttributeFilterSelected");
        console.log(data);
        this.customattributefilters = data
        this.$emit("filterSelected",data)
    },
    openCustomAttributeFilterDialog()
    {
      this.$refs.customattributedialog.showDialog()
    },
    searchSupplier()
    {
        
        clearInterval(this.intervalobj);
        this.intervalobj = setInterval(()=>{
            this.$emit("searchSupplier",this.filters["global"].value)
            clearInterval(this.intervalobj);
        },1000)
    },
    onPage(event)
    {        
        this.$emit("onPage",{event:event,customattribute_query:this.customattributefilters})
    },
    onSort(event)
    {        
        this.$emit("onSort",event)
    },
    onFilter(event)
    {
        //console.log("filter")
        this.$emit("filter",event)
    },
    selectCustomAttribute()
    {
        console.log(this.selected_customattribute) 
        this.customattribute_query = {            
            customattribute_id:null,
            customattribute_type:null,
            numerical_val:null,
            numerical_operation:null,
            text_val:null,
            text_operation:null,
        }
    },
    clearCustomAttributeSelection()
    {
        this.selected_customattribute = null
        this.customattribute_query = {
            customattribute_id:null,
            customattribute_type:null,
            numerical_val:null,
            numerical_operation:null,
            text_val:null,
            text_operation:null,
        }
        this.$emit("customattributeFiltered",this.customattribute_query)
    },
    customAttributeQuerySet()
    {
        this.customattribute_query.customattribute_id = this.selected_customattribute.id
        this.customattribute_query.customattribute_type = this.selected_customattribute.type
        this.$emit("customattributeFiltered",this.customattribute_query)
    },
  	async selectAction()
  	{
  		//console.log(this.selectedaction)
        console.log(this.selectedSuppliers)
        if(this.selectedaction.action=="add_to_project")
        {
            this.$refs.projects.showModal()
        }
        if(this.selectedaction.action=="add_to_flow")
        {
            this.$refs.flows.showModal()
        }

        if(this.selectedaction.action=="remove_from_project")
        {
            this.removeFromProject()
        }
        if(this.selectedaction.action=="remove_from_flow")
        {
            this.removeFromFlow()
        }
        if(this.selectedaction.action=="create_preaudit")
        {
            this.createPreaudit()
        }

        if(this.selectedaction.action=="update_custom_attribute")
        {
            this.$refs.customattributes.showModal()
        }
        if(this.selectedaction.action=="download_marking_report")
        {
            this.$refs.markingdownloads.showModal()
        }
        if(this.selectedaction.action=="delete")
        {
            console.log(this.selectedSuppliers)
            await this.$confirm.require({
            message: this.$store.state.languages.lang_phrases.bu_kaydi_silmek_istiyor_musunuz,
            header: this.$store.state.languages.lang_phrases.silme_uyarisi,
            icon: 'pi pi-exclamation-triangle',
            acceptClass: 'p-button-danger p-button-outlined',
            acceptLabel:this.$store.state.languages.lang_phrases.devam_et,
            rejectLabel:this.$store.state.languages.lang_phrases.iptal,
            accept: async () => {
                await this.$store.dispatch('ui/setDeletedState',false) 
                let formdata = await new  FormData()
                let suppliers = this.selectedSuppliers.map(item=>item.id)
                suppliers = JSON.stringify(suppliers)
                await this.generalSubmission(formdata,"/brand/delete_suppliers?suppliers="+suppliers,this.afterDeleteBrandSuppliers)
            },
            reject: () => {
                
            }
        });
            //this.$refs.flows.showModal()
        }
        //this.selectedaction = "placeholder"

  	},
    afterDeleteBrandSuppliers(response)
    {
        console.log(response.data)
        this.$emit("reloadData")
    },
    async removeFromFlow()
    {
        this.$confirm.require({
            message: this.$store.state.languages.lang_phrases.bu_kaydi_silmek_istiyor_musunuz,
            header: this.$store.state.languages.lang_phrases.silme_uyarisi,
            icon: 'pi pi-exclamation-triangle',
            acceptClass: 'p-button-danger p-button-outlined',
            acceptLabel:this.$store.state.languages.lang_phrases.devam_et,
            rejectLabel:this.$store.state.languages.lang_phrases.iptal,
            accept: async () => {                
                let formdata =  new  FormData()
                await console.log(this.selectedSuppliers)
                //return false
                formdata.append("selectedSuppliers",JSON.stringify(this.selectedSuppliers))
                this.generalSubmission(formdata,"flowsupplier/delete_multiple",this.afterDeleteFlowSupplier)
            },
            reject: () => {
                
            }
        });
    },

    async createPreaudit()
    {
        let formdata =  new  FormData()
        console.log(this.selectedSuppliers)
        
        formdata.append("selectedSuppliers",JSON.stringify(this.selectedSuppliers))
        this.generalSubmission(formdata,"flowsupplier/create_multiple_preaudit",this.afterDeleteFlowSupplier)
    },
    afterDeleteFlowSupplier(response)
    {
        this.$emit("renewList")
    },

    async removeFromProject()
    {
        this.$confirm.require({
            message: this.$store.state.languages.lang_phrases.bu_kaydi_silmek_istiyor_musunuz,
            header: this.$store.state.languages.lang_phrases.silme_uyarisi,
            icon: 'pi pi-exclamation-triangle',
            acceptClass: 'p-button-danger p-button-outlined',
            acceptLabel:this.$store.state.languages.lang_phrases.devam_et,
            rejectLabel:this.$store.state.languages.lang_phrases.iptal,
            accept: async () => {                
                let formdata =  new  FormData()
                await console.log(this.selectedSuppliers)
                let arr = []
                for(let item of this.selectedSuppliers)
                {
                    let element = {
                        id:item.id,
                        supplier_id:item.supplier_id,
                        projectperiod_id:item.projectperiod_id,
                        project_id:item.project_id,
                    }
                    arr.push(element)
                }
                //return false
                formdata.append("selectedSuppliers",JSON.stringify(arr))
                this.generalSubmission(formdata,"projectsupplier/delete_multiple",this.afterremoveFromProject)
            },
            reject: () => {
                
            }
        });
    },
    afterremoveFromProject(response)
    {
        this.$emit("renewList")
    },
    closemodal()
    {
        this.selectedaction = "placeholder"
    },
  	toggle(event,id) 
    {
        this.$refs['menu'+id].toggle(event);
    },
    gotoSupplier(id)
    {
        this.$router.push({ name: "Supplier", params:{ id:id} }) 
    }
  }
}
</script>

<style lang="scss" scoped>
.loading_overlay
{
    background-color:rgba(53, 47, 141, 0.5);
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    color:#fff;
    flex-direction:column;

}
::v-deep(.p-paginator) {
    .p-paginator-current {
        margin-left: auto;
    }
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #607D8B;
    }
}

::v-deep(.p-datepicker) {
    min-width: 25rem;

    td {
        font-weight: 400;
    }
}

::v-deep(.p-datatable.p-datatable-suppliers) {
    .p-datatable-header {
        padding: 1rem;
        text-align: left;
        font-size: 1.5rem;
    }

    .p-paginator {
        padding: 1rem;
    }

    .p-datatable-thead > tr > th {
        text-align: left;
    }

    .p-datatable-tbody > tr > td {
        cursor: auto;
    }

    .p-dropdown-label:not(.p-placeholder) {
        text-transform: uppercase;
    }
}
</style>